<template>
  <div class="media-dialog" v-if="isVisible">
    <div class="media-dialog__header">
      <button @click="hide" class="border-0 bg-transparent">
        <i class="fas fa-2x fa-times"></i>
      </button>
    </div>
    <div class="media-dialog__body">
      <loading v-if="!isInitialized"></loading>
      <contact-form
          v-if="isInitialized"
          v-bind="formData"
          @stored="onStored"
      ></contact-form>
    </div>
  </div>
</template>

<script>
import eventBus from "../../event-bus";
import BaseDialogFormWrapper from '../../components/dialog-form-wrapper';
import ContactForm from "../contact/form";
import Loading from '../../components/loading';

export default {
  extends: BaseDialogFormWrapper,

  components: {
    ContactForm,
    Loading,
  },

  props: {
    conversationId: Number,
  },

  methods: {
    /**
     * @param {string|undefined} message
     * @param {Object|null} model
     */
    onStored({message, model}) {
      _.isString(message) && this.$message.success(message);

      eventBus.$emit('contact-stored', {conversationId: this.conversationId, model: model});

      this.hide();
    },
  },

  created() {
    eventBus.$on('show-dialog-edit-contact', this.show);
  },

  beforeDestroy() {
    eventBus.$off('show-dialog-edit-contact', this.show);
  },
}
</script>

<style scoped>

</style>
